import blockInvestLogo from '../images/sponsors/blockinvest-logo.png'
import cryptoRuimLogo from '../images/sponsors/crypto-ruim-logo.jpg'
import cronquerorsNode from '../images/sponsors/cronquerors_node.jpg'
import cryptoConscious from '../images/sponsors/crypto_conscious.png'
import cryptotaxes from '../images/sponsors/cryptotaxes.png'
import cryptoedits from '../images/sponsors/cryptoedits.png'

const sponsorsData = [
    {
        imgAuthor: cryptoConscious,
        name: "Crypto Conscious",
        description: 'Youtuber. Learn about crypto and cosmos',
        link: 'https://www.youtube.com/channel/UCP-ZtZjC1UTxQcxPPcEXEbw',
        buttonLabel: 'View',
    },
    {
        imgAuthor: blockInvestLogo,
        name: "BlockInvest",
        description: 'Teaching and investing in Crypto',
        link: 'https://www.blockinvest.pt/',
        buttonLabel: 'Visit',
    },
    {
        imgAuthor: cryptoRuimLogo,
        name: "Criptoruim",
        description: 'Crypto in Portuguese',
        link: 'https://www.oblogruim.com',
        buttonLabel: 'Read',
    },
    {
        imgAuthor: cronquerorsNode,
        name: "CROnquerorsNode",
        description: 'Top 100 validator at Crypto.org',
        link: 'https://wallet.keplr.app/#/crypto-org/stake?modal=detail&validator=crocncl1s078nr9kp4ulsxgnsasnr3k6zg5q9erps348eg',
        buttonLabel: 'Stake CRO',
    },
    {
        imgAuthor: cryptotaxes,
        name: "Crypto & Taxes Portugal",
        description: 'Your trusted crypto & taxes partner in Portugal',
        link: 'https://www.cryptotaxesportugal.com',
        buttonLabel: 'Visit',
    },
    {
        imgAuthor: cryptoedits,
        name: "Crypto Edits",
        description: 'Professional-grade videos for crypto content creators',
        link: 'https://www.cryptoedits.com',
        buttonLabel: 'Visit',
    },
]

export default sponsorsData;
